<div [style.min-height]="'600px'">
  <div class="table-container header">
    <div class="table-hider" (click)="changeSorting('name')">
      <div class="h3-impaired-dark">
        {{ 'VERSION_VISUALLY_IMPAIRED.NAME' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === 'name'"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>

    <div class="table-hider" (click)="changeSorting('category')">
      <div class="h3-impaired-dark">
        {{ 'VERSION_VISUALLY_IMPAIRED.CATEGORY' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === 'category'"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>

    <div class="table-hider" (click)="changeSorting('developer')">
      <div class="h3-impaired-dark">
        {{ 'INFORMATION_PLACEMENT_FORM.DEVELOPER' | translate }}
      </div>
      <app-impaired-icon
        *ngIf="sorting.type === 'developer'"
        [invertColor]="true"
        [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
      ></app-impaired-icon>
    </div>
  </div>
  <div (click)="openApp($event, app)" class="table-container row" *ngFor="let app of appData$ | async">
    <div class="body1-impaired">
      {{ app.name }}
    </div>

    <div class="body1-impaired">{{ app.category }}</div>
    <div class="body1-impaired">{{ app.developer }}</div>
    <div class="option-container">
      <div class="app_store_block">
        <div class="status-container" *ngFor="let appState of app.appStores">
          <app-button-icon (clickOnButton)="goAppStore(appState.link)"
                           [iconName]="appState.icon"
                           [isIconFirst]="true"
                           [classSize]="'medium-impaired'"
                           [buttonName]="appState.name"
          ></app-button-icon>
        </div>
      </div>
    </div>
  </div>
</div>
